import { api } from './networkService';

class PagePaymentService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/payment/page`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch page payment error:', error);
            throw error;
        }
    }

    static async fetchAll(filters) {
        try {
            const response = await api.get(`api/user/payment/page`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch page payment error:', error);
            throw error;
        }
    }

    static async fetchAllPdf(filters) {
        try {
            const response = await api.get(`api/user/payment/page/all/pdf`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch page payment error:', error);
            throw error;
        }
    }

    static async add(pagePayment) {
        try {
            const cleanedPagePayment = Object.fromEntries(
                Object.entries(pagePayment).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/payment/page`, cleanedPagePayment);
            return response;
        } catch (error) {
            console.error('Add page payment error:', error);
            throw error;
        }
    }

    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/payment/page/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch page payment error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/payment/page/${id}`);
            return response;
        } catch (error) {
            console.error('Delete page payment error:', error);
            throw error;
        }
    }

    static async deletePost(id, postId) {
        try {
            const response = await api.put(`api/user/payment/page/${id}`, {
                postId
            });
            return response;
        } catch (error) {
            console.error('Delete page payment post error:', error);
            throw error;
        }
    }

    static async addPost(id, postId) {
        try {
            const response = await api.post(`api/user/payment/page/${id}`, {
                postId
            });
            return response;
        } catch (error) {
            console.error('Add page payment post error:', error);
            throw error;
        }
    }
}

export default PagePaymentService;
